import React from 'react';
import { Icon } from '@iconify/react';
import { TransactionData } from '../types';

interface TransactionUserCellProps {
  transaction: TransactionData;
}

const TransactionUserCell: React.FC<TransactionUserCellProps> = ({ transaction }) => {
  return (
    <div className="flex flex-col gap-2">
      <a
        href={`ht!tps://onlyfans.com/${transaction.subscriber.ofId}`}
        target="__blank"
        className=""
      >
        <div className="flex items-center gap-2">
          <span className="font-semibold text-sm">{transaction.subscriber.name}</span>
          <Icon
            icon="solar:square-top-down-linear"
            width={12}
            height={12}
            className="text-partner"
          />
        </div>
      </a>
    </div>
  );
};

export default TransactionUserCell;
